import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';
import { useMoneyMask } from '@redlink/core';
import { useLocale } from '@redlink/assets/locale';

export const PreviewShopPostCardTextBlock = memo(
  ({ title, categoryTitle, price, discount, style }) => {
    const { styles } = useStyle();
    const { getValue } = useMoneyMask();
    const { dictionary } = useLocale();

    const finalPrice = price - discount;
    const finalPriceText = `${getValue(finalPrice)} ${dictionary.moneyPostfix}`;
    const priceText = `${getValue(price)} ${dictionary.moneyPostfix}`;
    const hasDiscount = price !== finalPrice;

    return (
      <View style={[styles.textContainer, style]}>
        <View style={styles.titleContainer}>
          <Text style={styles.titleText}>{title}</Text>
          <Text style={styles.subtitleText}>{categoryTitle}</Text>
        </View>
        <View>
          <Text style={styles.finalPriceText}>{finalPriceText}</Text>
          {hasDiscount && <Text style={styles.priceText}>{priceText}</Text>}
        </View>
      </View>
    );
  }
);

export const PreviewShopSimplePostCardTextBlock = memo(
  ({ title, categoryTitle, price, discount, style }) => {
    const { styles } = useStyle();
    const { getValue } = useMoneyMask();
    const { dictionary } = useLocale();

    const finalPrice = price - discount;
    const finalPriceText = `${getValue(finalPrice)}`;

    return (
      <View style={[styles.textContainer, style]}>
        <View style={styles.titleContainer}>
          <Text style={styles.titleText}>{title}</Text>
          <Text style={styles.subtitleText}>{categoryTitle}</Text>
          <Space />
          <Text style={styles.titleText}>
            {finalPriceText}{' '}
            <Text style={styles.moneyPrefixText}>{dictionary.moneyPostfix}</Text>
          </Text>
        </View>
      </View>
    );
  }
);

const useStyle = createUseStyle(
  ({ colors, shadow, size, ltrFlexDirection }) => ({
    textContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    titleContainer: {
      flex: 1,
    },
    titleText: {
      fontSize: 14,
      color: colors.title,
      fontWeight: 'bold',
      textAlign: 'left',
    },
    subtitleText: {
      fontSize: 14,
      color: colors.subtitle,
      textAlign: 'left',
    },
    moneyPrefixText: {
      fontSize: 12,
      textAlign: 'left',
    },
    finalPriceText: {
      color: colors.title,
      fontSize: 17,
      fontWeight: 'bold',
    },
    priceText: {
      color: colors.subtitle,
      fontSize: 10,
      textDecorationLine: 'line-through',
      alignSelf: 'flex-end',
    },
  })
);
